import { FC, ReactNode } from 'react';
import { Modal as AntModal } from 'antd';
import styles from './Modal.module.scss';

export interface AntModalProps {
    open?: boolean;
    title?: string;
    children?: ReactNode;
    onOk?: () => void;
    onCancel?: () => void;
    footer?: ReactNode[];
    width?: number;
    destroyOnClose?: boolean
}

export const Modal:FC<AntModalProps> = ({
  open,
  title,
  onOk,
  onCancel,
  footer,
  width,
  destroyOnClose,
  children,
}: AntModalProps) => (
  <AntModal
    wrapClassName={styles.wrapper}
    open={open}
    title={title}
    onOk={onOk}
    onCancel={onCancel}
    footer={footer}
    width={width}
    destroyOnClose={destroyOnClose}
  >
    {children}
  </AntModal>
);
